import MediumDetailsModal from './MediumDetailsModal';

export default MediumDetailsModal;
